import DataBinder from 'src/lib/data_binder';

function PollSchema(d) {
  if ('percent' in d) {
    this.attr('.progress-bar', 'style', `width: ${d.percent}%`)
      .text('.js-percent', `${d.percent} %`);
  }

  if ('checked' in d) {
    const $scope = $(this.el).closest('.card-body');
    const $clearBtn = $('.js-poll-clear-btn', $scope);
    const isPollVoted = $('.card-items input', $scope).is(':checked');
    isPollVoted ? $clearBtn.removeClass('hidden') : $clearBtn.addClass('hidden');

    const wrapper = this.el.querySelector('.card-poll-item-content');
    const percent = wrapper.querySelector('.percent');
    const progress = wrapper.querySelector('.progress');

    if (percent && progress) { return; }

    d.partial && isPollVoted && wrapper.insertAdjacentHTML('beforeend', d.partial);
  }
}

export default DataBinder.create(PollSchema);
